import { pagination_params } from '../../shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = '';
  path = pagination_params(params);

  params.Codigo && (path = `${path !== '' ? `${path}&` : ''}Codigo=${params.Codigo}`);
  params.Descripcion &&
    (path = `${path !== '' ? `${path}&` : ''}Descripcion=${params.Descripcion}`);
  params.AceptaNegativo &&
    (path = `${path !== '' ? `${path}&` : ''}AceptaNegativo=${params.AceptaNegativo}`);
  params.CodigoUsuarioInventario &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoUsuarioInventario=${params.CodigoUsuarioInventario}`);
  params.InventarioActivo &&
    (path = `${path !== '' ? `${path}&` : ''}InventarioActivo=${params.InventarioActivo}`);
  params.FechaHoraInventario &&
    (path = `${path !== '' ? `${path}&` : ''}FechaHoraInventario=${params.FechaHoraInventario}`);
  params.Activo && (path = `${path !== '' ? `${path}&` : ''}Activo=${params.Activo}`);

  return path;
};
